import { Button } from '@panwds/react-ui';
import React from 'react';
import { SelectColumns } from '../SelectColumns/SelectColumns.esm.js';

function ButtonLabel({ columns, groupBy }) {
    if (groupBy.length === 0) {
        return React.createElement(React.Fragment, null, "Group By");
    }
    const groupedColumns = groupBy
        .map((columnId) => columns.find((c) => c.id === columnId))
        .filter((c) => !!c);
    return (React.createElement(React.Fragment, null,
        "Grouped By:",
        ' ',
        groupedColumns.map((column, index) => (React.createElement("span", { key: column.id },
            column.render('Header'),
            index + 1 < groupedColumns.length && ', ')))));
}
function GroupBySelect({ columns, groupBy, toggleGroupBy }) {
    const groupableColumns = columns.filter((c) => c.isVisible && !c.disableGroupBy);
    return (React.createElement(SelectColumns, { button: React.createElement(Button, { isMenu: true, style: { marginLeft: 0 } },
            React.createElement(ButtonLabel, { columns: columns, groupBy: groupBy })), columns: groupableColumns, label: "Select columns", showLabel: false, selectedColumnIds: groupBy, onSelectColumn: (c) => {
            toggleGroupBy(c);
        } }));
}

export { GroupBySelect };
//# sourceMappingURL=GroupBySelect.esm.js.map
